import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../componentes/Auth/AuthContext/AuthContext";

const AuthRedirect = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get("code");
    const API_URL = process.env.REACT_APP_API_URL || 'https://sic-conti-backend.vercel.app';

    if (code) {
      fetch(`${API_URL}/auth/exchange-token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code }),
      })
        .then(async (response) => {
          const data = await response.json();
          if (data.access_token) {
            login(data.access_token);

            // Recupera a URL de destino ou usa o dashboard como fallback
            const redirectUrl = localStorage.getItem("redirect_url") || "/dashboard";
            localStorage.removeItem("redirect_url"); // Limpa a URL armazenada
            navigate(redirectUrl); // Redireciona para a URL de destino
          } else {
            console.error("Erro: Token de acesso ausente.", data);
          }
        })
        .catch((error) => {
          console.error("Erro ao trocar token:", error);
        });
    } else {
      console.error("Authorization code não recebido.");
    }
  }, [navigate, login]);

  return <div>Processando autenticação...</div>;
};

export default AuthRedirect;
